import { AuxiliarMeta } from '~/layers/forms/models/globals/auxiliarMeta'

export type Identification = Nullable<{
  type: PropsTypesOf<typeof DocumentTypeEnum>['code']
  number: string
  nationality: AuxiliarMeta
  entityName: string
}>

function load(model?: Partial<Identification> | null): Identification {
  return {
    type: model?.type ?? DocumentTypeEnum.C.code,
    number: model?.number ?? null,
    nationality: model?.nationality ?? AuxiliarMeta.load(),
    entityName: model?.entityName ?? null,
  }
}

export const DocumentTypeEnum = {
  C: { label: 'Cédula', code: 'C', entity: 'Person' },
  P: { label: 'Pasaporte', code: 'P', entity: 'Person' },
  R: { label: 'RNC', code: 'R', entity: 'Business' },
} as const

function getTypeList(customerType: PropsTypesOf<typeof DocumentTypeEnum>['entity'] | null = null) {
  return Object.values(DocumentTypeEnum).filter(
    ({ entity }) => customerType === null || entity === customerType
  )
}

export const Identification = {
  load,
  getTypeList,
}
